var React = require('react');
var Modal = require('react-modal');
var FontAwesome = require('react-fontawesome');
var styles = require('./RadioButtonList.scss');

var RadioButtonList = React.createClass({
    propTypes: {
        id: React.PropTypes.string.isRequired,
        options: React.PropTypes.array.isRequired,
        value: React.PropTypes.oneOfType([
            React.PropTypes.number,
            React.PropTypes.string
        ]),
        group: React.PropTypes.string,
        onChange: React.PropTypes.func
    },
    getDefaultProps: function() {
        return {
            value: null,
            valueField: 'value',
            labelField: 'label',
            onChange: null,
            enabled: false,
            hidden: false
        };
    },
    getInitialState: function() {
        return {
            checked: this.props.value,
            modalIsOpen: false,
            valid: true
        }
    },
    componentWillReceiveProps: function(nextProps) {
        this.setState({
            checked: nextProps.value
        });
    },
    render: function() {
        var self = this;
        var classes = ['radio', 'input'];
        if (!self.props.enabled) {
            classes.push('disabled-view');
        }

        var options = self.props.options.map(function(option) {
            var modalClass = null;
            if (!option['modalHeader']) {
                modalClass = 'hidden';
            }
            var key = self.props.id + '_' + option[self.props.valueField];
            return (
                <label key={key} className={classes.join(' ')} htmlFor={key}>
                    <input onChange={self.handleChange} checked={self.state.checked === option[self.props.valueField]} type="radio" disabled={!self.props.enabled} id={key} value={option[self.props.valueField]} name={self.props.group} />
                    <i></i>
                    {option[self.props.labelField]}
                    <a href="javascript:void(0);" onClick={self.openModal.bind(self, option['modalHeader'], option['modalBody'])} className={modalClass}>
                        <FontAwesome name='info-circle' className={styles.info} />
                    </a>
                </label>
            )
        });
        classes = [];
        if (!this.state.valid) {
            classes.push('error-view');
        }
        if (this.props.hidden) {
            classes.push('hidden');
        }
        return (
            <div className={classes.length > 0 ? classes.join(' ') : null}>
                {options}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    className={styles.modal}
                    contentLabel='apa'
                    overlayClassName={styles.overlay}>

                    <div className={styles.header}>
                        <p>{this.state.modalHeader}</p>
                    </div>
                    <div className={styles.body}>{this.state.modalBody}</div>
                    <div className={styles.close}>
                        <button onClick={this.closeModal}>Close</button>
                    </div>
                </Modal>
            </div>
        )
    },
    handleChange: function(e) {
        if (this.props.onChange) {
            var change = {
                oldValue: this.state.checked,
                newValue: e.target.value
            };
            this.props.onChange(change);
        }
        this.setState({checked: e.target.value});
    },
    openModal: function(header, body) {
        this.setState({
            modalIsOpen: true,
            modalHeader: header,
            modalBody: body
        });
    },
    closeModal: function() {
        this.setState({modalIsOpen: false});
    },
    validate: function (text) {
        var textToValidate = text != null ? text : this.state.checked;
        var isValid = textToValidate != '';
        this.setState({
            valid: isValid
        });
        return isValid;
    }
});

module.exports = RadioButtonList;


// WEBPACK FOOTER //
// ./app/components/RadioButtonList.js